export default (f) => f();
//# sourceMappingURL=closure.mjs.map